import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const JobRequisitionDetailPageSkeleton = () => {
  return (
    <Box flexGrow gap="s16">
      <Skeleton width="full" height="s400" />
      <Skeleton width="full" height="s40" />
      <Skeleton width="full" height="s40" />
      <Skeleton width="full" height="s40" />
      <Skeleton width="full" height="s40" />
      <Skeleton width="full" height="s40" />
      <Skeleton width="full" height="s200" />
      <Skeleton width="full" height="s200" />
    </Box>
  )
}
